exports.config = {
    defaults: {
        __template: undefined,
        __image: 'https://www.tinaba.bancaprofilo.it/pj/p/img/social_square.jpg',

        __metaTags: {
            title: 'Tinaba presale',
            description: "",
            theme_color: '#FF5E00',

            og: {
                type: 'website',
                url: undefined,
                title: undefined,
                description: undefined,
                image: undefined,
            },

            twitter: {
                card: undefined,
                url: undefined,
                title: undefined,
                description: undefined,
                image: undefined,
            },

            msapplication: {
                tileColor: undefined,
                tileImage: undefined,
            },
        },
    },
    projects: [
        {
            id: {
                valid: 1,
                prod: 1
            },
            __influencerName: "Elisa Maino",
            __influencerCode: "elisa_maino",
            __influencerShortName: "Elisa",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Elisa Maino: vantaggi e offerte speciali!",
                description: "La Hit di Elisa Maino è arrivata! Fai subito il preordine!",
                og: {
                    description:"Carta Hit di Elisa Maino",
                    image: "ogimage_elisa_maino.jpg",
                }
            },
            __heroImage: {
                backgroundColor: "#F3DFD5",
                buttonColor: "#000000",
                color: "#000000",
                text:"RAGAZZI,<BR />BENVENUTI<BR />NEL MIO SHOP<BR />CREATO APPOSTA<BR />PER VOI."
            },            
            __youtubeVideo: 'https://www.youtube.com/embed/zORD_xt0H1U',
            __qrcode: {
                backgroundColorQrcode : "#F3DFD5",
                topBgImage: "70px",
                leftBgImage: "0px",
                widthBgImage: "100%"
            }
        },
        {
            id: {
                valid: 2,
                prod: 2
            },
            __influencerName: "Marta Losito",
            __influencerCode: "marta_losito",
            __influencerShortName: "Marta",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Marta Losito: vantaggi e offerte speciali!",
                description: "Entra a far parte della community di Marta Losito in modo ancora più esclusivo attraverso il suo Profilo Tinaba Hit. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Marta Losito: vantaggi e offerte speciali!",
                    image: "ogimage_marta_losito.jpg",
                }                
            },
            __heroImage: {
                backgroundColor: "#F7F5FD",
                buttonColor: "#5B3BBF",
                color: "#5B3BBF",
                text:"AMORI, ECCO<br />A VOI IL MIO<br />MONDO<br />IN UNO SHOP!"
            },  
            __youtubeVideo: 'https://www.youtube.com/embed/zORD_xt0H1U',
            __qrcode: {
                backgroundColorQrcode : "#F7F5FD",
                topBgImage: "0px",
                leftBgImage: "15%",
                widthBgImage: "85%"
            }
        },       
        {
            id: {
                valid: 3,
                prod: 3
            },
            __influencerName: "Valerio Mazzei",
            __influencerCode: "valerio_mazzei",
            __influencerShortName: "Valerio",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Valerio Mazzei: vantaggi e offerte speciali!",
                description: "Diventa parte della community esclusiva del Profilo Tinaba Hit di Valerio Mazzei ed entra nel suo mondo unico ricco di vantaggi. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Valerio Mazzei: vantaggi e offerte speciali!",
                    image: "ogimage_valerio_mazzei.jpg",
                }                   
            },
            __heroImage: {
                backgroundColor: "#C43B42",
                buttonColor: "#FFFFFF",
                color: "#000000",
                text:"REGÀ, LE MIE<br />PASSIONI PER<br />VOI NEL<br />MIO SHOP."
            },  
            __youtubeVideo: 'https://www.youtube.com/embed/zORD_xt0H1U',
            __qrcode: {
                backgroundColorQrcode : "#C43B42",
                topBgImage: "0px",
                leftBgImage: "0px",
                widthBgImage: "100%"
            }
        },    
        {
            id: {
                valid: 4,
                prod:4
            },
            __influencerName: "SighTanc",
            __influencerCode: "sightanc",
            __influencerShortName: "SighTanc",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di SighTanc: vantaggi e offerte speciali!",
                description: "Preordina ora il Conto Tinaba Hit di SighTanc per avere vantaggi esclusivi come prevendite e eventi speciali. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di SighTanc: vantaggi e offerte speciali!",
                    image: "ogimage_sightanc.jpg",
                }                   
            },
            __heroImage: {
                backgroundColor: "#EAEAEA",
                buttonColor: "#000000",
                color: "#000000",
                text:"BELLA REGÀ,<br />QUESTO È<br />IL MIO SHOP!"
            }, 
            __youtubeVideo: 'https://www.youtube.com/embed/zORD_xt0H1U',
            __qrcode: {
                backgroundColorQrcode : "#EAEAEA",
                topBgImage: "0px",
                leftBgImage: "0px",
                widthBgImage: "100%"
            }
        },      
        {
            id: {
                valid: 5,
                prod:5
            },
            __influencerName: "Gordon",
            __influencerCode: "gordon",
            __influencerShortName: "Gordon",
            __metaTags: {
                theme_color: '#FF5E00',
                title: "Conto Tinaba Hit di Gordon: vantaggi e offerte speciali!",
                description: "GRL PWR: questa è la parola d'ordine per entrare a far parte della community esclusiva di Gordon tramite il suo Profilo Tinaba Hit. Scarica l'App e registrati subito",
                og: {
                    description:"Conto Tinaba Hit di Gordon: vantaggi e offerte speciali!",
                    image: "ogimage_gordon.jpg",
                }                   
            },
            __heroImage: {
                backgroundColor: "#FFE9F1",
                buttonColor: "#E5146b",
                color: "#E5146b",
                text:"BENVENUTE<br />NEL MIO SHOP!<br />GRL PWR, AMO!"
            },
            __youtubeVideo: 'https://www.youtube.com/embed/zORD_xt0H1U',
            __qrcode: {
                backgroundColorQrcode : "#FFE9F1",
                topBgImage: "0px",
                leftBgImage: "0px",
                widthBgImage: "100%"
            }
        },                    
    ]
}